import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "technical-form" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = { class: "flex flex-row gap-2" }

import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

import {
  baseInput,
  baseSelect,
  baseTextarea,
  svgIcon,
} from "@/common/components";

import {
  AffiliatePayloadType,
  AffiliateType,
  AffiliateTypesEnum,
} from "@/common/types/affiliate";


export default /*@__PURE__*/_defineComponent({
  __name: 'technical',
  props: {
    data: {},
    title: {}
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const defaultData = {
  description: "",
  email: "",
  name: "",
  type: "",
  status: "ACTIVE",
};

const AffiliateTypes = computed(() =>
  Object.values(AffiliateTypesEnum).map((value) => ({
    option: t(`technical.types.${value}`),
    value,
  })),
);

const statusOptions = computed(() => [
  {
    option: t("common.labels.active"),
    value: "ACTIVE",
  },
  {
    option: t("common.labels.inactive"),
    value: "INACTIVE",
  },
]);

const payload = ref<AffiliatePayloadType>({ ...defaultData });

const disabled = ref(false);

function update() {
  emit("update-data", payload.value);
}

watchEffect(async () => {
  if (props.data) {
    const { status, member_id, description, email, name, type } = props.data;

    payload.value = {
      status,
      member_id,
      description,
      email,
      name,
      type,
    };

    disabled.value = true;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(svgIcon), {
            icon: "technical",
            size: "2.5rem"
          }),
          _createTextVNode(" " + _toDisplayString(__props.title), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(baseSelect), {
          modelValue: payload.value.type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.type) = $event)),
          value: payload.value.type,
          options: AffiliateTypes.value,
          required: true,
          "is-empty": false,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (update()))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.type")), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value", "options"]),
        _createVNode(_unref(baseSelect), {
          modelValue: payload.value.status,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.status) = $event)),
          value: payload.value.status,
          options: statusOptions.value,
          required: true,
          "is-empty": false,
          onChange: _cache[3] || (_cache[3] = ($event: any) => (update()))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.type")), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value", "options"])
      ]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.name,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.name) = $event)),
        value: payload.value.name,
        placeholder: _unref(t)('common.placeholders.name'),
        disabled: disabled.value,
        required: true,
        onBlur: _cache[5] || (_cache[5] = ($event: any) => (update()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder", "disabled"]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.email,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.email) = $event)),
        value: payload.value.email,
        placeholder: _unref(t)('common.placeholders.email'),
        disabled: disabled.value,
        required: true,
        onBlur: _cache[7] || (_cache[7] = ($event: any) => (update()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.email")), 1)
        ]),
        sufix: _withCtx(() => [
          _createVNode(_unref(svgIcon), { icon: "email" })
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder", "disabled"]),
      _createVNode(_unref(baseTextarea), {
        modelValue: payload.value.description,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((payload.value.description) = $event)),
        value: payload.value.description,
        placeholder: _unref(t)('common.placeholders.describe'),
        onBlur: _cache[9] || (_cache[9] = ($event: any) => (update()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"])
    ])
  ]))
}
}

})